import { createConfig, http } from 'wagmi'
import { mainnet, optimism } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'
import { getStoredRpcUrl } from '../utils/rpcSettings'

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || ''
const customOptimismRpc = getStoredRpcUrl()

export const config = createConfig({
  chains: [optimism, mainnet],
  connectors: [
    injected(),
    walletConnect({
      projectId,
      showQrModal: true,
      metadata: {
        name: 'Cohort',
        description: 'Permissionless token distribution protocol',
        url: 'https://makewith.you',
        icons: ['https://makewith.you/campfire.png'],
      },
    }),
  ],
  transports: {
    [optimism.id]: http(customOptimismRpc ?? undefined),
    [mainnet.id]: http(), // For ENS resolution
  },
})
